import { render, staticRenderFns } from "./TitleWithSubtitle.vue?vue&type=template&id=f192b030&"
import script from "./TitleWithSubtitle.vue?vue&type=script&lang=js&"
export * from "./TitleWithSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Container: require('/vercel/path0/components/general/Container.vue').default})
